export default function WalletIcon({ nudge }: { nudge?: boolean }) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.5 3C4.567 3 3 4.567 3 6.5V17C3 19.2091 4.79086 21 7 21H20C20.5523 21 21 20.5523 21 20V9C21 8.44772 20.5523 8 20 8H17V4C17 3.44772 16.5523 3 16 3H6.5ZM15 8V5H6.5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8H15ZM15.5 15.75C16.1904 15.75 16.75 15.1904 16.75 14.5C16.75 13.8096 16.1904 13.25 15.5 13.25C14.8096 13.25 14.25 13.8096 14.25 14.5C14.25 15.1904 14.8096 15.75 15.5 15.75Z'
        fill='currentColor'
      />
      {nudge ? <circle cx='21' cy='4' r='3' fill='var(--nudgebg)' /> : null}
    </svg>
  )
}

export function WalletAlternativeIcon() {
  return (
    <svg width='49' height='48' viewBox='0 0 49 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M36.5 6H4.5V42H40.5V34H44.5V14H40.5V6H36.5ZM36.5 34V38H8.5V10H36.5V14H20.5V34H36.5ZM40.5 30H24.5V18H40.5V30ZM32.5 22H28.5V26H32.5V22Z'
        fill='currentColor'
      />
    </svg>
  )
}
